/* globals _ */
;(function ($, window) {
  'use strict'

  window.eah = window.eah || {}

  // scripts for community page and modules found on community pages
  eah.floatingElement = (function () {
    const initialize = function () {
      setupFloatingElement()
    }

    function overrideWidths () {
      // return
      //
      // const $floatingElement = $('[data-floating-element]')
      //
      // if (true || $floatingElement.length) {
      //   const bodyWidth = $(window).width()
      //   $('body').width(bodyWidth).css('width', bodyWidth)
      //   $('.globalNav, .globalNavMobile, .inpage-nav, .spmenu-vertical').width(bodyWidth).css('width', bodyWidth)
      //   $('[data-floating-element]').width(bodyWidth).css('width', bodyWidth)
      // }
    }

    function setupFloatingElement () {
      overrideWidths()

      const $floatingElement = $('[data-floating-element]')

      if ($floatingElement.length) {
        const feParam = $floatingElement.attr('data-floating-element')
        const desktopOnly = (feParam === 'desktop-only')
        const mobileOnly = (feParam === 'mobile')
        const bodyWidth = $(window).width()

        // console.log('checking body width', bodyWidth, desktopOnly, mobileOnly);
        if (desktopOnly && bodyWidth < 1024) {
          return
        } else if (mobileOnly && bodyWidth > 768) {
          return
        }

        let elementTop = $floatingElement.offset().top
        const elementHeight = $floatingElement.outerHeight()
        const marginBottom = parseInt($floatingElement.css('margin-bottom'), 10)

        const checkForFloater = _.debounce(function () {
          // console.log("checking for floater ....");
          // have to calc everytime since nav changes size
          let topOffset = 0
          const regularNav = $('.nav__wrapper:visible')
          const mobileNav = $('.nav--mobile:visible')
          const desktopNav = $('.nav--desktop:visible')
          if (regularNav.length) {
            topOffset += parseInt(regularNav.height(), 10)
          }
          if (mobileNav.length) {
            topOffset += parseInt(mobileNav.height(), 10)
          }
          if (desktopNav.length) {
            topOffset += parseInt(desktopNav.height(), 10)
          }

          const paddingTop = elementHeight + marginBottom
          const scrollTop = $(window).scrollTop()
          // const vars = [
          //   ['top offset', topOffset],
          //   // ['window width', $('html').width()],
          //   // ['window factor', windowFactor],
          //   ['pure scrolltop', scrollTop],
          //   ['calc scrolltop', (scrollTop + topOffset)],
          //   ['elementTop', elementTop],
          //   ['element height', elementHeight],
          //   ['margin bottom', marginBottom]
          // ]
          // console.table(vars);

          if ((scrollTop + topOffset) >= elementTop) { // was 46
            // console.log("stickied");
            $floatingElement.addClass('floating')
            $floatingElement.next(':visible').css('padding-top', paddingTop + 'px')
          } else {
            // console.log("unstickied");
            $floatingElement.removeClass('floating')
            $floatingElement.next(':visible').css('padding-top', 0)
          }
        }, 13) // NOTE: any higher and it feel sluggish

        checkForFloater()

        window.addEventListener('scroll', checkForFloater)
        window.addEventListener('resize', function () {
          // Only recalculate when the nav isn't floating.
          if ($('[data-floating-element]').not('.floating').length) {
            elementTop = $('[data-floating-element]').offset().top
            // console.log("RECALCULATE NavTop to " + navTop);
          }

          checkForFloater()
          overrideWidths()
        })
      }
    }

    return {
      initialize: initialize
    }
  }())

  $(function () {
    eah.floatingElement.initialize()
  })
}(jQuery, window))
